/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import _ from "lodash";

import { TenantTypesEnum } from "Constants/TenantTypes";
import { IApplicationQuestionResponse } from "Interfaces/Application/IApplicationQuestionResponse";

/**
 * Gets the default API timeout configuration. (in MilliSeconds)
 * @returns {number} The timeout.
 */
export function getDefaultApiTimeOutConfiguration(): number {
  if (process.env.REACT_APP_DEFAULT_API_TIMEOUT) {
    return +process.env.REACT_APP_DEFAULT_API_TIMEOUT;
  }

  // based on .net core default timeout values and taking in to account slow connections
  return 150000;
}

/**
 * Gets the tenant while the consolidation of the MSA to MLSA is complete.
 * @returns {TenantTypesEnum} One of the three standard tenants (MVP, RD, MLSA)
 */
export function getTenant(tenant: TenantTypesEnum): TenantTypesEnum {
  if (tenant === TenantTypesEnum.MSP) return TenantTypesEnum.MLSA;

  return tenant;
}

/**
 * Function to add @microsoft.com to emails in people picker component.
 * @param input
 * @returns
 */
export function onInputChange(input: string): string {
  const outlookRegEx = /@.*/g;
  const emailAddress = outlookRegEx.exec(input);

  if (emailAddress && emailAddress[0]) {
    return `${input.substring(0, input.length - emailAddress[0].length)}@microsoft.com`;
  }

  return input;
}

/**
 * Function to group application questions by section and question id.
 * @param applicationQuestions
 * @returns
 */
export function GetApplicationQuestionsGroupBySectionAndByQuestionId(
  applicationQuestions: IApplicationQuestionResponse[] | undefined
): any {
  return _.chain(applicationQuestions)
    .groupBy((question) => question.questionSection)
    .mapValues((questions) =>
      _.chain(questions)
        .groupBy((question) => `${question.questionId}-${question.questionLocKey}`)
        .map((groupedQuestions) => {
          const { questionId, questionLocKey, questionText, orderBy } = groupedQuestions[0];
          const questionResponseText = _.map(groupedQuestions, "questionResponseText").join(", ");
          return { questionId, questionLocKey, questionText, questionResponseText, orderBy };
        })
        .value()
    )
    .value();
}
